import React, { useEffect, useState } from "react";
import { Box, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes } from "../../../../../../../redux/bourse/select_commodities";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        height:50,
        margin:5,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        [theme.breakpoints.down("950")]: {
            minWidth: '48%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box:{
        margin:0,
    }
}))

export default function Index({ handleChange, state }) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const stateReducer = useSelector((state) => state.select_commodities_reducer);
    const [value, setValue] = useState('');


    const apiSubmit = () => {
        let payload = {
            data: value
                ? {
                    persianName: value
                }
                : {},
            size: 1000,
        }
        dispatch({
            type: actionTypes.selectCommoditiesBourseAsync,
            payload: payload,
        });
    };

    useEffect(() => {
        apiSubmit();
    }, [value]);

    const handelChangeState = (event) => {
        setValue(event?.target?.value)
    }


    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                width="100%"
                height="50px"
            >
                <Autocomplete
                    size={"small"}
                    id="combo-box-demo"
                    options={stateReducer?.data}
                    getOptionLabel={(option) => option?.id}
                    value={state?.['commodity_id']?.id }
                    onChange={(event, value) => handleChange(value, "commodity_id")}
                    onKeyUp={(event) => handelChangeState(event)}
                    noOptionsText={
                        stateReducer?.loading 
                        ? "در حال بارگذاری..." 
                        :stateReducer?.data?.length === 0
                        ?'کالای یافت نشد'
                        :null
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="جستجو کالا"
                            variant="outlined"
                            // InputProps={{
                            //     ...params.InputProps,
                            //     endAdornment: (
                            //         <>
                            //             {stateReducer?.loading ? "Loading..." : null}
                            //             {/* {params.InputProps.endAdornment} */}
                                       
                            //         </>
                            //     ),
                            //     }}
                        />
                    )}
                />
            </Box>
        </div>)
}
